import { useMemo } from 'react';

export const playgroundsTag = 'Spielplätze';

export const isPlaygroundsFilterSelected = filter => {
    if (!filter.tags) {
        return false;
    }

    const currentTags = filter.tags?.values && Array.isArray(filter.tags?.values)
        ? filter.tags.values
        : (filter.tags || []);

    return currentTags.includes(playgroundsTag);
};

export const usePlaygroundsFilter = (filter, removeTags = []) => useMemo(() => {
    const playgroundsFilter = {
        ...filter,
    };

    // A lot of playgrounds are not a POI as they don't have a description
    delete playgroundsFilter.isPOI;

    const currentTags = filter.tags?.values && Array.isArray(filter.tags?.values)
        ? filter.tags.values
        : (filter.tags || []);

    // Make sure the playgrounds tag is included in the tags list
    playgroundsFilter.tags = {
        operation: 'AND',
        values: [...new Set([...currentTags, playgroundsTag])],
    };

    // Remove tags if needed (used to remove the type tags of tag dropdown because playgrounds always only have the
    // playground type.
    if (removeTags.length > 0) {
        playgroundsFilter.tags.values = playgroundsFilter.tags.values.filter(tag => (
            tag === playgroundsTag || !removeTags.includes(tag)
        ));
    }

    return playgroundsFilter;
}, [filter, removeTags]);
